<template>
  <div>
    <h3 class="textProperty">
      {{ this.category.name }}/{{ this.subcategory.name }}
    </h3>
    <div class="parentProperty">
      <div class="childProperty-1 galery">
        <div class="box">
          <div
            v-for="(image, index) in this.property.images"
            :key="image.id"
            draggable
            v-on:dragstart="onMouseDown(index)"
            v-on:dragend="onMouseUp()"
            v-on:dragenter="onMouseOver(index)"
          >
            <div class="divImagesProperty">
              <img
                class="imageProperty pointer"
                :src="image.image"
                @click="pictureViewShow(index)"
                v-bind:class="imageSetOpacity[index]"
              />
              <a v-if="dataManagement" href="javascript:void(0)"
                class="close_btn"
                @click="removeImage(image.id)">&times;</a>
            </div>
          </div>
          <div v-if="dataManagement"
            style="width: 150px; height: 150px;
            margin-top: 16px; margin-bottom: 16px;">
            <div style="margin-top: 16px;">
            <button class="btnSalvar"
              style="width: 150px;"
              @click="applySortImages">
              Salvar Ordem
            </button>
            </div>
          </div>
        </div>
        <div class="files_upload">
          <ImageUpload
            v-if="dataManagement"
            @uploadimages="uploadImages"
            :property_id="property.id"
            :cleanFiles="cleanFilesImageUpload"
          />
        </div>
      </div>
      <div class="childProperty-2" :key="dataManagement">
        <h2 class="textProperty">Ref. {{ property.id }}</h2>
        <table id="customers">
          <tr>
            <td>Preço</td>
            <td v-if="!dataManagement">{{ formatCurrency(property.price) }}</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.price"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Categoria</td>
            <td>
              <select
                style="width: 100%;"
                :value="category.id"
                @change="changeCategory">
                <option
                  v-for="(category) in this.categories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{category.name}}
                </option>
              </select>
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Sub-categoria</td>
            <td>
              <select
                style="width: 100%;"
                :value="subcategory.id"
                @change="changeSubcategory">
                <option
                  v-for="(subcategory) in (this.categories.find((category) => {
                    return category.id === parseInt(category.id, 10);
                  }) || { subcategories: [] }).subcategories"
                  :key="subcategory.id"
                  :value="subcategory.id"
                >
                  {{subcategory.name}}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Quartos</td>
            <td v-if="!dataManagement">{{ property.bedrooms }}</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.bedrooms"
              />
            </td>
          </tr>
          <tr>
            <td>Banheiros</td>
            <td v-if="!dataManagement">{{ property.bathrooms }}</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.bathrooms"
              />
            </td>
          </tr>
          <tr>
            <td>Endereço</td>
            <td v-if="!dataManagement">
              {{ property.address }}, {{ property.number }} -
              {{ property.neighborhood }} - {{ property.town }}
            </td>
            <td v-if="dataManagement">
              <input
                style="text-align: center;"
                v-model="property.address"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Número</td>
            <td>
              <input
                type="number"
                style="text-align: center;"
                v-model="property.number"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Bairro</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.neighborhood"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Cidade</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.town"
              />
            </td>
          </tr>
          <tr>
            <td>Garagem</td>
            <td v-if="!dataManagement">{{ property.garage }} Carro(s)</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.garage"
              />
            </td>
          </tr>
          <tr>
            <td>Tam. do Imóvel</td>
            <td v-if="!dataManagement">{{ property.area_facility }} m²</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.area_facility"
              />
            </td>
          </tr>
          <tr>
            <td>Tam. do Terreno</td>
            <td v-if="!dataManagement">{{ property.area_land }} m²</td>
            <td v-if="dataManagement">
              <input
                type="number"
                style="text-align: center;"
                v-model="property.area_land"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Quadra</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.square"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Lote</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.lot"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Registro de imóvel</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.registration"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Nome proprietário</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_name"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>RG proprietário</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_id"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>CPF proprietário</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_cpf"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Telefone 01</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_fone1"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Telefone 02</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_fone2"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Telefone 03</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_fone3"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Telefone 04</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.owner_fone4"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Condições</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.restrict.parley"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Breve descrição</td>
            <td>
              <textarea
                rows="5"
                style="text-align: center;"
                v-model="property.brief_description"
              />
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Visível</td>
            <td>
              <CheckboxSwitch v-model="property.isVisible"></CheckboxSwitch>
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Vendido</td>
            <td>
              <CheckboxSwitch v-model="property.sold"></CheckboxSwitch>
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Destaque</td>
            <td>
              <CheckboxSwitch v-model="property.highlight"></CheckboxSwitch>
            </td>
          </tr>
          <tr v-if="dataManagement">
            <td>Youtube</td>
            <td>
              <input
                style="text-align: center;"
                v-model="property.youtube"
              />
            </td>
          </tr>
        </table>
        <p v-if="!dataManagement">{{ property.description }}</p>
        <textarea
          v-if="dataManagement"
          v-model="property.description"
          rows="10"
        />
        <div style="width: 100px; height: 40px; margin: auto;
          margin-top: 16px; margin-bottom: 16px;">
        <button v-if="dataManagement" class="btnSalvar" @click="patchProperty">
          Salvar
        </button>
        </div>
        <iframe
          v-show="property.youtube"
          :src="formatYoutubeLink(property.youtube)"
          allowfullscreen="allowfullscreen"
        >
        </iframe>
      </div>
      <div v-show="property.sold">
        <img :src="`../img/${category.name}.png`" class="imgSoldRented" />
      </div>
    </div>
    <PictureView
      style="z-index:101;"
      :isVisible="this.pictureViewVisible"
      @onclickclose="pictureViewClose"
      :image="this.imageView"
      @onclickdot="currentSlide"
      @onclickplusslides="plusSlides"
      :imagesTotal="this.property.images.length"
      :imageSelected="this.imageSelected"
    />
    <MyConfirm
      text="Confirma a exclusão da imagem?"
      :paramReturn="imageToDelete"
      @confirmclick="confirmImageDelete"
      @cancelclick="cancelImageDelete"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import PictureView from '@/components/pictureView.vue';
import ImageUpload from '@/components/imageUpload.vue';
import CheckboxSwitch from '@/components/checkboxSwitch.vue';
import MyConfirm from '@/components/myConfirm.vue';

export default {
  props: {
    id: String,
  },
  components: {
    PictureView,
    ImageUpload,
    CheckboxSwitch,
    MyConfirm,
  },
  data() {
    return {
      pictureViewVisible: false,
      imageSelected: 0,
      imageView: null,
      property: {},
      changeImagesRequested: false,
      cleanFilesImageUpload: 0,
      category: {},
      subcategory: {},
      imagePressed: -1,
      imageSetOpacity: [],
      imageToDelete: -1,
    };
  },
  computed: {
    ...mapState('properties', ['properties', 'dataManagement']),
    ...mapState('categories', ['categories']),
  },
  watch: {
    id: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.propertyUpdate(newValue);
      },
    },
    properties: {
      immediate: true,
      deep: true,
      handler() {
        this.propertyUpdate(this.property.id);
        if (this.changeImagesRequested) {
          this.cleanFilesImageUpload += 1;
        }
      },
    },
  },
  methods: {
    ...mapMutations('properties', ['setImagesToUpload', 'setProperty']),
    ...mapActions('properties', [
      'saveImages',
      'deleteImage',
      'sortImages',
      'saveProperty',
    ]),
    propertyUpdate(newValue) {
      [this.property] = this.properties.filter((property) => {
        return property.id === parseInt(newValue, 10);
      });
      if (this.property) {
        [this.category] = this.categories.filter((category) => {
          return (
            category.subcategories.filter((subcategory) => {
              return subcategory.id === this.property.subcategory_id;
            }).length > 0
          );
        });
        [this.subcategory] = this.category.subcategories.filter(
          (subcategory) => {
            return subcategory.id === this.property.subcategory_id;
          },
        );
      }
    },
    formatCurrency(value) {
      if (value) {
        return value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
      }
    },
    changeCategory(e) {
      [this.category] = this.categories.filter((category) => {
        return category.id === parseInt(e.target.value, 10);
      });
      if (this.category) {
        [this.subcategory] = this.category.subcategories;
        this.property.subcategory_id = this.subcategory.id;
      }
    },
    changeSubcategory(e) {
      [this.subcategory] = this.category.subcategories.filter(
        (subcategory) => {
          return subcategory.id === parseInt(e.target.value, 10);
        },
      );
      if (this.subcategory) {
        this.property.subcategory_id = this.subcategory.id;
      }
    },
    formatYoutubeLink(id) {
      return `https://www.youtube.com/embed/${id}`;
    },
    pictureViewShow(id) {
      this.pictureViewVisible = true;
      this.imageSelected = id;
      this.imageView = this.property.images[id].image;
    },
    pictureViewClose() {
      this.pictureViewVisible = false;
    },
    currentSlide(index) {
      this.imageSelected = index;
      this.imageView = this.property.images[index].image;
    },
    plusSlides(n) {
      if (this.imageSelected + n > this.property.images.length - 1) {
        this.imageSelected = 0;
      } else if (this.imageSelected + n < 0) {
        this.imageSelected = this.property.images.length - 1;
      } else {
        this.imageSelected += n;
      }
      this.imageView = this.property.images[this.imageSelected].image;
    },
    onMouseDown(imageId) {
      this.imagePressed = imageId;
      this.imageSetOpacity = Array(this.property.images.length).fill('');
      this.imageSetOpacity[imageId] = 'imageOpacity';
    },
    onMouseUp() {
      this.imagePressed = -1;
      this.imageSetOpacity = Array(this.property.images.length).fill('');
    },
    onMouseOver(imageId) {
      if (this.imagePressed >= 0 && imageId !== this.imagePressed) {
        const propertyTmp = { ...this.property };
        const imagesTmp = this.property.images.slice();
        const tmp = imagesTmp[this.imagePressed];
        imagesTmp.splice(this.imagePressed, 1);
        imagesTmp.splice(imageId, 0, tmp);
        propertyTmp.images = imagesTmp;
        this.property = { ...propertyTmp };
        this.imagePressed = imageId;
        this.imageSetOpacity = Array(this.property.images.length).fill('');
        this.imageSetOpacity[imageId] = 'imageOpacity';
      }
    },
    nextInput(event) {
      document.getElementById(parseInt(event.target.id, 10) + 1).focus();
    },
    uploadImages(files) {
      this.setProperty(this.property);
      this.setImagesToUpload(files);
      this.saveImages();
      this.changeImagesRequested = true;
    },
    removeImage(imageId) {
      this.imageToDelete = imageId;
    },
    applySortImages() {
      this.setProperty(this.property);
      this.sortImages();
    },
    confirmImageDelete(imageId) {
      this.deleteImage({ propertyId: this.property.id, imageId });
      this.imageToDelete = -1;
    },
    cancelImageDelete() {
      this.imageToDelete = -1;
    },
    patchProperty() {
      this.setProperty(JSON.parse(JSON.stringify(this.property)));
      this.saveProperty();
    },
  },
};
</script>

<style>
td:focus-within {
  background-color: #ddd;
}
textarea, input {
  width: 100%;
}
.parentProperty {
  display: flex;
  flex-direction: column;
}
@media (min-width: 850px) and (orientation: landscape) {
  .parentProperty {
    position: relative;
    flex-direction: row;
  }
  .childProperty-1 {
    flex-basis: 50%;
  }
  .childProperty-2 {
    flex-basis: 50%;
    min-width: 400px;
  }
}
.btnSalvar {
  border-radius: 3px;
  width: 100px;
  height: 40px;
}
.btnSalvar:hover, .btnSalvar:active {
  opacity: 0.75;
}
.btnSalvar:active {
  width: 98px;
  height: 38px;
  margin-top: 2px;
}
.galery {
  position: relative;
  flex-direction: row;
  margin-top: 16px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
}
.pointer {
  cursor: pointer;
}
.divImagesProperty {
  height: 150px;
  width: 150px;
  position: relative;
}
.imageProperty {
  border-radius: 3px;
  margin: 2px;
  max-width: 100%;
  max-height: 100%;
}
.imageOpacity {
  opacity: 0;
  transition: 0s;
}
.imgSoldRented {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(40%);
}
.textProperty {
  text-align: left;
  margin: 16px;
}

#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

iframe {
  width: 350px;
  height: 260px;
}

.files_upload {
  position: relative;
}
</style>
